module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid22_960x865.2c14974.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid22_960x865.jpg
// module id = F9vY
// module chunks = 0